<template>
    <a-modal v-model="visible" title="添加账号" >
        <template slot="footer">
            <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
            确定
            </a-button>
            <a-button key="back"   @click="handleCancel">
            取消
            </a-button>
        </template>

        <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
          <a-form-item label="账号名">
            <a-input placeholder="请输入" allowClear v-decorator="['alias', { rules: 
            [
            { required: true, message: '请输入账号名!' },  
            { pattern: /^[A-z0-9\u4e00-\u9fa5]{1,20}$/, message: '仅支持20位以内中英文数字字符'}
           ] }]"/>
          </a-form-item>
          <a-form-item label="手机号码">
            <a-input placeholder="请输入" allowClear v-decorator="['account', { rules: [{ required: true, message: '请输入手机号!' },{ pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号码'}], initialValue:'' }]"/>
          </a-form-item>
          <a-form-item label="密码" >
              <a-input type="password" allowClear placeholder="密码至少8位字符"
               v-decorator="['password',
                { rules: 
                  [
                    { required: true, message: '请输入密码' },
                    { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/, message: '请输入合法字符，字母/数字至少包含2种'}
                  ] 
                },
              ]"
             />
            </a-form-item>
            <a-form-model-item label="角色" >
                <a-radio-group   disabled v-decorator="['type', { rules: [{ required: true, message: '请输入手机号!' }],initialValue:mode }]">
                    <a-radio value="1">
                    子账号
                    </a-radio>
                    <a-radio value="2">
                    供应商账号
                    </a-radio>
                    <a-radio value="3">
                    渠道商账号
                    </a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="账号性质" v-if="mode =='2'">
                <a-radio-group   v-decorator="['nature', { rules: [{ required: true, message: '请选择账号性质!' }],initialValue:'1' }]">
                    <a-radio value="1">
                    预付
                    </a-radio>
                    <a-radio value="2">
                    后付
                    </a-radio>
                </a-radio-group>
            </a-form-model-item>
        </a-form>

    </a-modal>
</template>
<script>
export default {
  props:{
    mode:{
      type:String,
      default:'1'
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      formLayout: "horizontal",
      form: this.$form.createForm(this, { name: "coordinated" }),
    };
  },
  created(){
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let url = '';
          if (this.mode=='1') {
            url = '/manager/appendRecord'
          } else if(this.mode=='2'){
             url = '/supplier/appendRecord'
          }else if(this.mode=='3'){
             url = '/distributor/appendRecord'
          }
          this.$http.post(url,values).then(res=>{
            if (res.result) {
              this.$message.success('添加成功')
              this.handleCancel();
              this.$emit("getdata");
            }else{
              this.$message.warning(res.message)
            }
            
            
          })
        }
      });
    },
    showModal() {
      this.form.resetFields();
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
      this.form.resetFields();
      // this.form.setFieldsValue({
      //   note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,
      // });
    }
  }
};
</script>
